import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { Building2, Hospital, Boxes, Stethoscope, ShieldCheck, Layers, ArrowRight } from "lucide-react";

const CARDS = [
  { to: "/app/facility", icon: Hospital, title: "Facility Identity", desc: "Name, logo, address and contact details." },
  { to: "/app/departments", icon: Boxes, title: "Department Configuration", desc: "Add, edit and activate departments." },
  { to: "/app/services", icon: Stethoscope, title: "Service Configuration", desc: "Manage the service catalogue and pricing." },
  { to: "/app/users", icon: Building2, title: "User Management", desc: "Assign users to facilities and roles." },
  { to: "/app/roles", icon: ShieldCheck, title: "Role Management", desc: "Create roles and assign permissions." },
  { to: "/app/modules", icon: Layers, title: "Module Management", desc: "View and toggle enabled modules." },
];

export default function TenantSettings() {
  const { auth } = useAuth();
  return (
    <div data-testid="tenant-settings-page">
      <PageHeader title="Settings" subtitle="Configure your facility, departments, services, users, roles and modules." />

      <div className="bg-white border border-slate-200 rounded-md p-6 mb-6">
        <div className="text-[11px] font-mono uppercase tracking-wider text-slate-400 mb-3">Organisation</div>
        <div className="flex items-center gap-4">
          <span className="h-12 w-12 rounded-md bg-slate-100 text-slate-500 grid place-items-center"><Building2 className="h-6 w-6" /></span>
          <div>
            <div className="font-display text-lg font-semibold text-slate-900">{auth?.organisation?.name}</div>
            <div className="text-sm text-slate-500">{auth?.organisation?.org_type} · {auth?.organisation?.subscription_plan} plan</div>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <Link key={c.to} to={c.to} data-testid={`settings-card-${c.to.split("/").pop()}`}
            className="group bg-white border border-slate-200 rounded-md p-5 hover:border-blue-300 hover:shadow-sm transition-all">
            <span className="h-10 w-10 rounded-md bg-blue-50 text-blue-700 grid place-items-center"><c.icon className="h-5 w-5" /></span>
            <div className="mt-3 font-display font-semibold text-slate-800 flex items-center gap-1.5">{c.title}<ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-blue-500 group-hover:translate-x-0.5 transition-transform" /></div>
            <p className="text-sm text-slate-500 mt-1">{c.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
